import { InjectionToken } from '@angular/core';

declare module '@df/core/df-core.config' {
    export interface IDfConfig {
        gtm?: {
            /**
             * Container id
             */
            id?: string;
            /**
             * Container env
             */
            env?: string;
            /**
             * Container auth
             */
            auth?: string;
        };
    }
}

export namespace NModuleGtm {
    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_MODULE_GTM_OPTIONS');

    export interface IModuleOptions {
        /**
         * List of fields picked to pass to GTM
         */
        customerFields: string[];

        /**
         * Maps step name to step index.
         * This field is not mandatory. If the map is not provided, it will be evaluated automatically
         * based on the checkout steps and corresponding step orders.
         * Example: {account:1,delivery:2,payment:3}
         */
        checkoutSteps?: { [key: string]: number };
    }
}
